export const PRODUCT_PRICE_MULTIPLE_OF = 0.01;
export function getProductPrice(product) {
    return product?.fixedPriceOptions?.price || '0';
}

//# sourceMappingURL=product-price.js.map